import PropTypes from 'prop-types'

export const MetricsDashboardPropTypes = {
  userDetails: PropTypes.object.isRequired,
  safeRetirementStatus: PropTypes.object.isRequired,
  safeRetirementStatusLabels: PropTypes.object.isRequired,
  groupRiskProfiles: PropTypes.array.isRequired,
  groupInflation: PropTypes.number.isRequired,
  groupName: PropTypes.string.isRequired,
  groupCapitalGrowthChartData: PropTypes.object.isRequired,
  assetsUnderAdvice: PropTypes.object.isRequired,
  assetsUnderManagement: PropTypes.object.isRequired,
  averageRetirementBudget: PropTypes.object.isRequired,
  averageCurrentBudget: PropTypes.object.isRequired,
  colors: PropTypes.object.isRequired,
  featureToggles: PropTypes.object.isRequired
}
